import { render } from "./App.vue?vue&type=template&id=485828c4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=485828c4&lang=less"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__